import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, BasicTooltip, DownloadFile, Icon, PrintFile, SimpleModal, toast } from '@livable/saas-react-components';
import { Button, TextField } from '@mui/material';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { exportCSVFromDataGrid } from 'src/utils/exportCSV';
import useStyles from './styles';
const PreviewStatementsModal = observer(_ref => {
  var _store$statement$getP, _store$statement$send, _store$homeDashboardS;
  let disabled = _ref.disabled,
    isCurrentAllocationCycle = _ref.isCurrentAllocationCycle,
    month = _ref.month,
    name = _ref.name,
    propertyId = _ref.propertyId,
    year = _ref.year;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const propertyStatementsByMonth = store.statement.propertyStatementsByMonth.get(propertyId + '_' + month + '_' + year) || [];
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    emailClicked = _useState2[0],
    setEmailClicked = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  const _useState7 = useState(10),
    _useState8 = _slicedToArray(_useState7, 2),
    pageSize = _useState8[0],
    setPageSize = _useState8[1];
  const getPropertyStatements = async () => {
    const resp = await store.statement.getPropertyStatementsAsync.run({
      month,
      propertyId,
      year
    });
    return resp;
  };
  const sendPaperStatements = async data => {
    const resp = await store.statement.sendPaperStatementAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (!emailClicked) return;
    sendPaperStatements({
      paperStatementId: emailClicked
    }).then(() => toast('success', {
      body: ['The statement has been sent.']
    }) // ? i18n
    ).finally(() => setEmailClicked(''));
  }, [emailClicked]);
  useEffect(() => {
    if (isLoading) getPropertyStatements().finally(() => setIsLoading(false));
  }, [isLoading]);
  const renderCell = (parameter, dollarSign, left) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, dollarSign ? '$' : '', parameter);
  const renderHeader = (text, right) => /*#__PURE__*/React.createElement("span", {
    className: right && classes.rightAlign
  }, text);
  const columns = [{
    align: 'left',
    field: 'unitName',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Unit',
    isExportable: true,
    renderCell: params => renderCell(params.value),
    renderHeader: () => renderHeader('Unit', true),
    valueGetter: params => params.row.unitName
  }, {
    field: 'accountId',
    flex: 1,
    headerName: t('residencies_page.active_residents_statements_table'),
    isExportable: true,
    renderCell: params => renderCell(store.account.profilesFullName.get(params.value)),
    renderHeader: () => renderHeader(t('residencies_page.active_residents_statements_table')),
    valueGetterForExport: params => store.account.profilesFullName.get(params.row.accountId)
  }, {
    align: 'right',
    field: 'chargesTotal',
    flex: 1,
    headerAlign: 'right',
    headerName: t('general.charges'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('general.charges')),
    valueGetter: params => params.row.chargesTotal
  }, {
    align: 'right',
    field: 'creditsTotal',
    flex: 1,
    headerAlign: 'right',
    headerName: t('general.credits'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('general.credits')),
    valueGetter: params => params.row.creditsTotal
  }, {
    align: 'right',
    field: 'utilityBillsTotal',
    flex: 1,
    headerAlign: 'right',
    headerName: t('residencies_page.utility_bills'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('residencies_page.utility_bills')),
    valueGetter: params => params.row.utilityBillsTotal
  }, {
    align: 'right',
    field: 'utilityCapsTotal',
    flex: 1,
    headerAlign: 'right',
    headerName: t('residencies_page.utility_caps'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('residencies_page.utility_caps')),
    valueGetter: params => params.row.utilityCapsTotal
  }, {
    align: 'right',
    field: 'statementCapsTotal',
    flex: 1,
    headerAlign: 'right',
    headerName: t('residencies_page.statement_caps'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('residencies_page.statement_caps')),
    valueGetter: params => params.row.statementCapsTotal
  }, {
    align: 'right',
    field: 'total',
    flex: 1,
    headerAlign: 'right',
    headerName: t('general.total'),
    isExportable: true,
    renderCell: params => renderCell(params.value, true),
    renderHeader: () => renderHeader(t('general.total')),
    valueGetter: params => params.row.total
  }, {
    flex: 1,
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: !store.account.profilesEmailValue.get(params.row.accountId) && !store.account.profilesNewEmailValue.get(params.row.accountId) ? 'Resident has no email' : t('general.send_statement'),
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.wrappedTooltip
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => setEmailClicked(params.row.id),
      size: "small",
      variant: "actionIcon",
      disabled: !store.account.profilesEmailValue.get(params.row.accountId) && !store.account.profilesNewEmailValue.get(params.row.accountId),
      'custom-attribute': '666-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "mail-send"
    })))), /*#__PURE__*/React.createElement(PrintFile, {
      fileId: params.row.fileId,
      getUrlAsyncCallback: async () => {
        const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
          fileId: params.row.fileId,
          isPreview: true
        });
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          return resp.response;
        }
      },
      href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
        fileId: params.row.fileId
      })),
      showText: false,
      tooltipText: t('general.print_statement'),
      variant: "actionIcon"
    }), /*#__PURE__*/React.createElement(DownloadFile, {
      fileId: params.row.fileId,
      usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
      showText: false,
      store: store,
      variant: "actionIcon",
      tooltipText: t('general.download_statement')
    }))
  }];
  const handleDownloadCsv = () => {
    exportCSVFromDataGrid({
      columns,
      name: "statement_".concat(name, ".csv"),
      rows: propertyStatementsByMonth
    });
  };
  const CustomColumnMenu = props => {
    return /*#__PURE__*/React.createElement(GridColumnMenu, _extends({}, props, {
      slots: {
        columnMenuUserItem: () => /*#__PURE__*/React.createElement("div", {
          className: classes.exportCSV
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: handleDownloadCsv,
          size: "small",
          variant: "contained"
        }, "Export CSV"))
      },
      slotProps: {
        columnMenuUserItem: {
          displayOrder: 15
        }
      }
    }));
  };
  const trigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: "actionIcon",
    'custom-attribute': '667-new-billing-module'
  }, isCurrentAllocationCycle ? 'Preview' : 'Review', " statement");
  const handleOpen = () => {
    setIsLoading(true);
    setIsOpen(true);
  };
  const isAnyRequestInProgress = isLoading || ((_store$statement$getP = store.statement.getPropertyStatementsAsync) === null || _store$statement$getP === void 0 ? void 0 : _store$statement$getP.inProgress) || ((_store$statement$send = store.statement.sendPaperStatementAsync) === null || _store$statement$send === void 0 ? void 0 : _store$statement$send.inProgress);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setIsOpen(false),
    handleOpen: handleOpen,
    isOpen: isOpen,
    noPadding: true,
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.buildingInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.buildingAddress,
    title: "Statement ".concat(name),
    trigger: trigger,
    variant: "large"
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isAnyRequestInProgress
  }), /*#__PURE__*/React.createElement(DataGrid, {
    columns: columns,
    getRowId: row => row.id,
    pageSize: pageSize,
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    disableRowSelectionOnClick: true,
    autoHeight: true,
    columnHeaderHeight: 80,
    rowHeight: 60,
    hideFooterSelectedRowCount: true,
    getRowClassName: () => classes.row,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    slots: {
      columnMenu: CustomColumnMenu,
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '668-new-billing-module'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    rows: propertyStatementsByMonth
  }));
});
export default PreviewStatementsModal;